import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import {Http} from '@angular/http';
import {Constants} from '../../util/Constants';

@Injectable()
export class SharedService {
  // Observable string sources
  public emitChangeSource = new Subject();

  // Observable string streams
  changeEmitted$ = this.emitChangeSource.asObservable();
  public menuNo: String;

  // Service message commands
  emitChange(change: string) {
    this.emitChangeSource.next(change);
  }

  constructor(public http: Http) {
  }

  /**
   * create user
   * @param formData
   * @param token
   */
  createUser(formData: any, token: string) {
    return this.http.post(Constants.CREATE_ADMIN_URL, formData, Constants.getRequestOption(token))
      .map(res => res.json());
  }

  updateUser(userFormData: any, id, token: string) {
    return this.http.put(Constants.UPDATE_ADMIN_URL + id, userFormData, Constants.getRequestOption(token))
      .map(res => res.json());
  }

  selectedMenu(menuNo) {
    this.menuNo = menuNo;
  }

  checkUser(user) {
    return this.http.get(Constants.SEARCH_USER_URL + user, Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
      .map(res => res.json());
  }


  checkUserExist(email='',mobileNo='') {
    return this.http.get(Constants.SEARCH_USER_URL + '?email=' + email+ '&mobileNo=' + mobileNo, Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
      .map(res => res.json());
  }

  checkIfNumberExist(mobileNo='') {
    return this.http.get(Constants.SEARCH_USER_URL + '?mobileNo=' + mobileNo, Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
      .map(res => res.json());
  }





  getProfile(email) {
    return this.http.get(Constants.SEARCH_USER_URL + '?email=' + email, Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
      .map(res => res.json());
  }
}



// WEBPACK FOOTER //
// ./src/app/services/shared-service/shared.service.ts